import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";
import VerifyEmailAccountOverlay from "../common/overlays/VerifyEmailAccountOverlay";
import { usePrevious } from "../hooks/usePrevious";
import { useHistory } from "react-router-dom";
import { signOutUser } from "../../features/auth/authActions";
import { signOutFirebase } from "../../app/firestore/firebaseService";
import { toast } from "react-toastify";

export const SIGNED_IN_TOAST_ID = "signedInToastId";

export default function AppEnvironmentMode({ isOverlayPage, children }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { initialised } = useSelector((state) => state.async);
  const { currentUserAccount } = useSelector((state) => state.account);
  const { appMode, isCookieConsent } = useSelector((state) => state.app);

  const previousRelease = usePrevious(appMode.release);

  useEffect(() => {
    if (!previousRelease || appMode.release === "") return;
    if (previousRelease !== appMode.release) {
      window.location.reload(true);
    }
  }, [appMode.release, previousRelease]);

  useEffect(() => {
    if (isCookieConsent && initialised) {
      ReactGA.event({
        category: "Visits",
        action: "App loaded",
        label: appMode.release,
      });
    }
  }, [appMode.release, initialised, isCookieConsent]);

  useEffect(() => {
    if (!currentUserAccount) {
      toast.dismiss(SIGNED_IN_TOAST_ID);
    }
  }, [currentUserAccount]);

  useEffect(() => {
    if (!currentUserAccount) {
      history.push("/sign-in");
    }
  }, [currentUserAccount, history]);

  if (currentUserAccount && !currentUserAccount.isAdmin) {
    dispatch(signOutUser());
    signOutFirebase();
    // return <MaintenanceOverlay />;
  }

  if (
    !isOverlayPage &&
    currentUserAccount &&
    !currentUserAccount.isAccountVerified
  ) {
    return <VerifyEmailAccountOverlay />;
  }

  return <div className="app-environment-mode">{children}</div>;
}

/////////////////////////////////////
